var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{class:( _obj = {
        alert: true
    }, _obj[("alert--" + _vm.variant)] = _vm.variant, _obj )},[_c('div',{staticClass:"alert__wrapper"},[_c('div',{staticClass:"alert__content"},[_vm._t("default")],2),_c('div',{staticClass:"alert__close-btn",on:{"click":_vm.onCloseBtnClick}},[_c('generic-close-big',{staticClass:"alert__icon"})],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }